import config from '../../config.json';

const LOCAL_HOSTNAMES = new Set(['localhost', '[::1]']);

function hasWindow() {
    return typeof window !== 'undefined' && !!window.location;
}

export function isLocalRuntime() {
    if (!hasWindow()) {
        return config.ENVIRONMENT !== 'PROD';
    }

    const { hostname } = window.location;
    return LOCAL_HOSTNAMES.has(hostname) || /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(hostname);
}

export function isProductionRuntime() {
    return config.ENVIRONMENT === 'PROD' || !isLocalRuntime();
}

export function getApiBaseUrl() {
    return isProductionRuntime() ? config.SERVER_URL : config.SERVER_URL_LOCAL_HOST;
}

export function getCanonicalWebOrigin() {
    return 'https://www.gst.ezybill.in';
}